<template>
  <transition name="modal-fade">
    <Modal @close="close">
      <div id="container" class="apply_st">
        <div v-on-clickaway="close" class="inner">
          <div class="box_wrap">
            <div class="box tac">
              <div ref="focus" class="box_title">
                <h2 class="pub_choice">출판사 선택</h2>
                <button class="close" @click="savePublish">
                  <img src="@/assets/images/login_join/close.png" alt="닫기" />
                </button>
              </div>
              <div class="search_area">
                <form @submit.prevent="searchPublishList">
                  <legend class="blind">검색</legend>
                  <div class="search_box">
                    <label for="search-book" class="lab hidden">{{
                      $t('views.help.faq.2181')
                    }}</label>
                    <input
                      id="search-book"
                      v-model="searchNm"
                      type="text"
                      name="search"
                      placeholder="출판사명을 입력하세요"
                      value=""
                    />

                    <button
                      type="button"
                      class="btn_search"
                      @click="searchPublishList"
                    >
                      <span class="svg_search"></span
                      ><span class="blind">검색</span>
                    </button>
                  </div>
                </form>
              </div>
              <div class="select_area flex">
                <div v-for="(d, i) in selectedPb" :key="i + 'arr'">
                  <span class="univNm">{{ d.publisherNm }}</span>
                  <span class="white_close" @click="cancel(i)">
                    <img
                      src="@/assets/images/login_join/white_close.png"
                      alt="취소"
                    />
                  </span>
                </div>
              </div>
              <div class="uniList">
                <div class="pd_wrap">
                  <h3>
                    <span></span>
                    <span>출판사명</span>
                    <span>위치</span>
                    <span>연락처</span>
                  </h3>
                </div>
                <div class="scroll_wrap">
                  <EmptyData
                    v-if="getPublishList.length === 0"
                    data-tp="검색 결과"
                  />
                  <ul
                    v-if="getPublishList.length > 0"
                    ref="publishBox"
                    @scroll="morePublishList($event)"
                  >
                    <li v-for="(pb, i) in getPublishList" :key="i + 'arr'">
                      <label>
                        <span
                          ><input
                            v-model="selectedPb"
                            :value="pb"
                            type="checkbox"
                        /></span>
                        <span style="text-align: left;">{{
                          pb.publisherNm
                        }}</span>
                        <span>{{ pb.address }}</span>
                        <span>{{ pb.telNo }}</span>
                      </label>
                    </li>
                  </ul>
                </div>
              </div>
              <button class="choice_complete" @click="savePublish">
                선택완료
              </button>
            </div>
          </div>
        </div>
        <!--  -->
      </div>
    </Modal>
  </transition>
</template>

<script>
import { mapGetters } from 'vuex'
import EmptyData from '../common/EmptyData.vue'
// import axios from '@/store/axios'

export default {
  name: 'PublishModal',
  components: { EmptyData },
  data() {
    return {
      searchNm: '',
      isShowModal: false,
      showErrorModal: false,
      currentPage: 1,
      applyPerPage: 10,
      set: '',
      inOnModal: false,
      className: '',
      classSem: '',
      classSchool: '',
      class: '',
      bookData: '',
      modalMsg: '',
      modalSubMsg: '',
      modalTitleTxt: '',
      selectedPb: [],
      searchTp: '',
      isDigging: false,

      publishers: []
    }
  },
  computed: {
    ...mapGetters(['getPublishList', 'getPublishInfo'])
  },
  destroyed() {
    this.$store.commit('resetPublish')
    // Object.assign(this.$data, this.$options.data.apply(this))
  },
  mounted() {
    // this.$store.commit('resetPublish')
    this.searchPublishList()
  },
  methods: {
    async morePublishList(e) {
      if (
        e.target.scrollHeight - 10 <=
          e.target.clientHeight + e.target.scrollTop &&
        this.isDigging === true
      ) {
        this.isDigging = false
        this.currentPage++
        await this.$store
          .dispatch('fetchPublishList', {
            searchNm: this.searchNm,
            pageRow: this.applyPerPage,
            pageNo: this.currentPage
          })
          .then((res) => {
            if (res.length === 10) {
              this.isDigging = true
            } else {
              this.isDigging = false
              return ''
            }
          })
      } else {
        return ''
      }
      // e.stopPropagation()
      // if (
      //   this.getPublishInfo.totalCount / this.applyPerPage <=
      //   this.currentPage
      // ) {
      //   return
      // }
      // if (
      //   this.$refs.publishBox.scrollHeight - this.$refs.publishBox.scrollTop ==
      //   this.$refs.publishBox.clientHeight
      // ) {
      //   this.currentPage = this.currentPage + 1

      //   await this.$store.dispatch('fetchPublishList', {
      //     searchNm: this.searchNm,
      //     pageRow: this.applyPerPage,
      //     pageNo: this.currentPage
      //   })
      // }
    },

    async searchPublishList() {
      this.currentPage = 1
      this.$refs.publishBox?.scrollTo && this.$refs.publishBox.scrollTo(0, 0)
      this.isDigging = true
      try {
        await this.$store.dispatch('fetchPublishList', {
          searchNm: this.searchNm,
          pageRow: this.applyPerPage,
          pageNo: this.currentPage,
          searchTp: this.searchTp || 'BY_NAME'
        })
      } catch (err) {
        console.log(err)
      }
    },

    cancel(i) {
      // selectedPb

      this.selectedPb.splice(i, 1)
    },
    savePublish() {
      const x = this.selectedPb.map((e) => {
        return { publisherNm: e.publisherNm, publisherCd: e.publisherCd }
      })
      this.$emit('pbList', x)
    },
    closeModal() {
      this.isShowModal = false
      this.showErrorModal = false
    },
    toggleErrorModal() {
      this.modalTitleTxt = '알림창'
      this.showErrorModal = !this.showErrorModal
    },
    close() {
      this.$emit('close')
    }
  }
}
</script>
<style src="@/assets/css/page_join.css" scoped></style>
<style lang="scss" scoped>
@import '../../../src/assets/scss/_variables.scss';
// 학지추가
.select_area::-webkit-scrollbar {
  width: 10px;
  height: 5px;
  border-radius: 10px;
}
.uniList ul::-webkit-scrollbar {
  width: 5px;
  height: 10px;
  border-radius: 10px;
}
.uniList ul::-webkit-scrollbar-thumb {
  width: 5px;
  height: 10px;
  background-color: rgb(15, 99, 143);
  border-radius: 10px;
}
.select_area::-webkit-scrollbar-thumb {
  background-color: rgb(15, 99, 143);
  border-radius: 10px;
}
.select_area::-webkit-scrollbar-track {
  border-radius: 10px;
}
.input_t_wrap {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0px 12px;
}
.t_20 {
  top: 20% !important;
}
// 학지추가
h2 {
  color: $h_BLUE_01;
}
.select_area {
  height: 48px;
  align-items: center;
  overflow: scroll;
  margin-top: 12px;
  div {
    min-width: 100px;
    height: 40px;
    border-radius: 22px;
    background: #8de9e4;
    color: #0f638f;
    line-height: 40px;
    // margin: 15px 10px 15px 0;
    margin-right: 8px;
    // display: flex;
    .univNm {
      padding-left: 10px;
      display: inline-block;
      min-width: 70px;
    }
    .close {
      padding: 0 10px;
      // flex: 1;
      // text-align: left;
    }
  }
}
.search_area {
  width: 100%;
  margin: 0 auto;
  line-height: 48px;
  border-radius: 12px;

  .search_box {
    background: #f0f5fa;
    width: 100%;
    height: 48px;
    border-radius: 12px;
    margin: 0 auto;
    .btn_search {
      height: 100%;
    }
    input {
      // width: calC(100% - 70px)
      width: 100%;
      height: 100%;
      padding-left: 24px;
      margin: 0 auto;
      border-radius: 12px;
      background-color: inherit;
      font-size: 15px;
    }
    input::placeholder {
      color: $h_BLUE_01;
    }
  }
  .btn_search {
    right: 10px;
  }
}
// .section .inner {
//   padding: 132px 0 124px;
// }
#container {
  min-height: auto;
}
.apply_st {
  width: 100% !important;
  .inner {
    padding: 0;
    .close_btn {
      right: 7%;
    }
    .box_wrap {
      padding-bottom: 89px;
      width: 100%;
      max-width: 920px;
      margin: 0 auto;
      .box {
        width: 100%;
        max-width: 920px;
      }
    }
  }
  .btn_wrap .box_btn {
    width: 100px;
    margin: 0 10px;
  }
}
.uniList {
  width: 100%;
  border-top: 1px solid $h_BLUE_01;
  margin: 25px 0;
  h3 {
    height: 60px;
    display: flex;
    align-items: center;
    span:first-child {
      flex: 1;
    }
    span {
      font-weight: 500;
      font-size: 1.2em;
      line-height: 23px;
      flex: 3;
    }
    span:nth-child(3) {
      flex: 6;
    }
  }
  ul {
    max-height: 40vh;
    overflow: auto;
  }
  li:first-child {
    border-top: 1px solid #d6e7f1;
  }
  li {
    border-bottom: 1px solid #d6e7f1;
    height: 60px;
    label {
      cursor: pointer;
      width: 100%;
      height: 60px;

      display: flex;
      align-items: center;

      input {
        width: 32px;
        height: 32px;
        appearance: none;
        background-color: #f0f5fa;
        background-image: url("data:image/svg+xml,%3Csvg width='20' height='14' viewBox='0 0 20 14' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath opacity='0.2' d='M19 1.57602L7.13322 13.2759C7.06177 13.3469 6.97677 13.4033 6.88311 13.4417C6.78945 13.4802 6.68899 13.5 6.58753 13.5C6.48607 13.5 6.38561 13.4802 6.29196 13.4417C6.1983 13.4033 6.11329 13.3469 6.04184 13.2759L1 8.30494L2.09137 7.22892L6.58753 11.6467L17.9086 0.5L19 1.57602Z' fill='%23778899' stroke='%23778899' stroke-width='0.5'/%3E%3C/svg%3E%0A");
        background-position: center center;
        background-repeat: no-repeat;
        background-size: 20px 14px;
        border-radius: 3px;
      }
      input:checked {
        background-color: #5587eb;
        background-image: url("data:image/svg+xml,%3Csvg width='20' height='14' viewBox='0 0 20 14' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M19 1.57602L7.13322 13.2759C7.06177 13.3469 6.97677 13.4033 6.88311 13.4417C6.78945 13.4802 6.68899 13.5 6.58753 13.5C6.48607 13.5 6.38561 13.4802 6.29196 13.4417C6.1983 13.4033 6.11329 13.3469 6.04184 13.2759L1 8.30494L2.09137 7.22892L6.58753 11.6467L17.9086 0.5L19 1.57602Z' fill='white' stroke='white' stroke-width='0.5'/%3E%3C/svg%3E%0A");
      }
      span {
        font-size: 1em;
        flex: 3;
      }
      span:nth-child(1) {
        flex: 1;
        line-height: 8px;
      }
      span:nth-child(2) {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      span:nth-child(3) {
        flex: 6;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
  }
}
.apply_formlist {
  text-align: left;
  margin-bottom: 60px;
}
.apply_formlist .form_wrap li {
  padding-left: 148px;
  position: relative;
}
.apply_formlist .form_wrap li:first-child input {
  width: calc(100% - 120px);
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.apply_formlist .form_wrap li input {
  width: 100%;
}
.apply_formlist .form_wrap li p {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 0;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 23px;
  letter-spacing: -0.03em;
  height: 22px;
}

.book_search {
  width: 112px;
  height: 48px;
  text-align: center;
  line-height: 48px;
  background: #67788a;
  color: #fff;
  font-size: 16px;
  border-radius: 3px;
  font-style: normal;
  font-weight: 500;
  position: absolute;
  right: 0;
  top: 0;
}
.ly_alert {
  width: 540px;
  padding: 65px 58px 60px;
}
.ly_alert .ly_inner {
  padding: 0 !important;
  text-align: center;
  background-color: #f0f5fa !important;
}
.ly_alert .ly_inner strong {
  padding-top: 83px;
  padding-bottom: 8px;
  display: block;
  //   background: url(../../assets/images/pop_msg/msg_pod2.png) no-repeat top center;
}
.ly_alert .ly_inner p {
  color: #627283;
  font-size: 16px;
  margin-top: 0;
  letter-spacing: -0.03em;
  word-break: keep-all;
}
.ly_alert .ly_inner .btnWrap {
  margin-top: 24px;
}
.choice_complete {
  width: 300px;
  height: 56px;
  background: #008df3;
  border-radius: 12px;
  border: none;
  font-family: 'pretendard-medium';
  font-weight: 600;
  font-size: 18px;
  line-height: 56px;
  color: #fff;
}
@media (max-width: 1024px) {
  .box_wrap {
    padding: 48px 0px !important;
    border-radius: 20px;
  }
  //   .apply_st .box_wrap,
  //   .apply_st .box_wrap .box {
  //     width: 100%;
  //   }
  //   #container {
  //     min-height: auto !important;
  //   }
  //   .section .inner {
  //     padding: 20px 0;
  //   }
  //   .apply_st .box_wrap {
  //     padding: 50px 0;
  //     border-radius: 0;
  //   }
}
@media (max-width: 767px) {
  .box_wrap {
    padding: 20px 0 !important;
    .box_title {
      margin-bottom: 1.35em;
    }
  }
  h3,
  label {
    span:nth-child(4) {
      display: none;
    }
  }

  //   .apply_formlist .form_wrap li {
  //     padding-left: 68px;
  //   }
  //   .apply_formlist .form_wrap li:first-child input {
  //     width: calc(100% - 80px);
  //   }
  //   .book_search {
  //     width: 70px;
  //   }
}
// @media (max-width: 480px) {
.apply_st {
  .inner {
    .box_wrap {
      padding: 20px 0 20px 20px !important;
      .box_title {
        position: relative;
        padding-right: 20px;
        .close {
          position: absolute;
          width: 17px;
          height: 17px;
          top: 5px;
          right: 20px;
          > img {
            width: 100%;
          }
        }
      }
    }
  }
}
.pub_choice {
  color: #000000;
  font-size: 20px;
  letter-spacing: 0;
}
.select_area {
  overflow-x: scroll;
  overflow-y: hidden;
  div {
    display: flex;
    justify-content: center;
    gap: 5px;
    background: #0d99ff;
    line-height: 32px;
    height: 32px;
    min-width: 116px;
    align-items: center;
    .univNm {
      color: #ffffff;
      font-size: 13px;
      width: 65px;
      overflow-x: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      padding-left: 3px;
    }
    .white_close {
      width: 18px;
      height: 18px;
      > img {
        width: 100%;
        vertical-align: top;
      }
    }
  }
}
.search_area {
  margin-top: 5px;
  .search_box {
    background-color: transparent;
    // border: 1px solid #dddddd;
    border-radius: 8px;
    padding-right: 20px;
    .btn_search {
      right: 35px;
      .svg_search {
        background-image: url('../../assets/images/login_join/ic_search.png');
        background-size: cover;
      }
    }
    input[name='search'] {
      border: 1px solid #dddddd;
      outline: none;
      color: #333333;
      padding: 0 16px;
      font-family: 'pretendard-medium';
      letter-spacing: 0;
      &::placeholder {
        color: #999999;
      }
      &:focus {
        border: 1px solid #008df3;
      }
    }
  }
}
.uniList {
  border-top: none;
  margin: 10px 0 10px;
  .pd_wrap {
    padding-right: 20px;
    h3 {
      height: 44px;
      background-color: #f6f6f6;
      border-top: 1px solid #000000;
      span {
        font-size: 15px;
        font-weight: 400;
        color: #777777;
        &:nth-child(2) {
          text-align: left;
        }
      }
    }
  }
}
.scroll_wrap {
  padding-right: 5px;
  ul {
    padding-right: 10px;
    &::-webkit-scrollbar {
      width: 4px;
    }
    &::-webkit-scrollbar-thumb {
      background-color: #555555;
    }
    li {
      padding: 0;
      gap: 16px;
      border-bottom: 1px solid #e8e8e8;
      height: 56px;
      &:nth-child(1) {
        border-top: 1px solid #e8e8e8;
      }
      span {
        font-size: 13px;
        letter-spacing: 0;
        font-family: 'pretendard-medium';
        &:nth-child(2) {
          color: #333333;
          line-height: 20px;
        }
        &:nth-child(3) {
          white-space: normal;
          color: #777777;
          line-height: 20px;
        }
      }
      label {
        height: 56px;
        input {
          width: 18px;
          height: 18px;
          background-image: url('../../assets/images/login_join/circle_check.png');
          background-color: transparent;
          background-size: cover;
          &:checked {
            background-color: transparent;
            background-image: url('../../assets/images/login_join/circle_checked.png');
          }
        }
      }
    }
  }
}
// }
@media (max-width: 480px) {
  .scroll_wrap {
    ul {
      li {
        span {
          &:nth-child(3) {
            text-align: left;
          }
        }
      }
    }
  }
}
</style>
